import 'reset-css';
import Cookies from 'js-cookie';

/**
 * Store UTM codes in a cookie so that
 * we can dump them into MKTO forms later
 */
export const onRouteUpdate = ({ location }) => {
  const queryCodes = location.search.match(/(utm_[^&]+)/g) || [];

  if (!queryCodes.length) return;

  const utmCodes = queryCodes.reduce((result, code) => {
    const [key, val] = code.replace('utm_', '').split('=');
    result[key] = val;
    return result;
  }, {});

  Cookies.set('utm_codes', utmCodes, {
    domain: location.hostname,
    expires: 30, // days
  });
};
